import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { ManualTarget } from '@/shared/config/manual';

import { useManualUrl } from './use-manual-url';

interface HelpLinkProps {
  /** Manual node id or path; renders nothing when absent. */
  target?: ManualTarget | null;
  className?: string;
}

/** Icon button linking to the RITA manual page for the current language. */
export function HelpLink({ target, className }: HelpLinkProps) {
  const { t } = useTranslation();
  const href = useManualUrl(target);

  if (!href) {
    return null;
  }

  const label = t('navigation.help.title', 'Help');

  return (
    <Button asChild variant="ghost" size="icon" className={cn('h-9 w-9', className)}>
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
        <HelpCircle className="w-4 h-4" />
      </a>
    </Button>
  );
}
